import React, { useCallback } from "react";
import _every from "lodash/every";
import _find from "lodash/find";

import Screen from "./ConnectedScreen";
import ListItem from "../components/ListItem";

export default function CityScreen({ cityId, cities, setCity }) {
  let city;

  const isDisabled = _every(cities, (city) => city.disabled);

  if (!isDisabled) {
    if (cityId) {
      city = _find(cities, (city) => city.id === cityId);
    } else {
      city = _find(cities, (city) => !city.disabled);
    }
  }

  const onNext = useCallback(() =>
    setCity({ cityId: city.id, countryId: city.country_id })
  );

  return (
    <Screen
      {...{
        title: "Meet escort in...",
        isActive: true,
        onNext,
        nextDisabled: !city,
      }}
    >
      {cities.map(({ id, name, disabled, country_id: countryId }) => (
        <ListItem
          {...{
            key: id,
            title: name,
            active: city && city.id === id,
            disabled,
            onPress: () => setCity({ cityId: id, countryId }),
          }}
        />
      ))}
    </Screen>
  );
}
